import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const logisticsOrderStatus = v.union(
  v.literal("draft"),
  v.literal("confirmed"),
  v.literal("processing"),
  v.literal("ready"),
  v.literal("shipped"),
  v.literal("delivered"),
  v.literal("cancelled"),
);

export const logisticsOrderPaymentStatus = v.union(
  v.literal("pending"),
  v.literal("partial"),
  v.literal("completed"),
  v.literal("refunded"),
);

export const validatorLogisticsOrder = v.object({
  orderNumber: v.string(),
  orderCode: v.optional(v.number()),
  qrCode: v.string(),
  senderId: v.optional(v.id("clients")),
  status: logisticsOrderStatus,
  paymentStatus: logisticsOrderPaymentStatus,
  // Totals (calculated from packages)
  totalPackages: v.number(),
  totalVolumeCF: v.number(),
  totalWeight: v.number(),
  totalPrice: v.number(),
  totalAdvancePayment: v.optional(v.number()),
  netTotal: v.optional(v.number()),
  totalPaid: v.number(),
  // Optional shipment assignment
  shipmentId: v.optional(v.id("shipments")),
  // Default recipient for the order (used when creating new packages)
  recipientId: v.optional(v.id("recipients")),
  recipientAddressIndex: v.optional(v.number()),
  // Dates
  confirmedAt: v.optional(v.number()),
  shippedAt: v.optional(v.number()),
  deliveredAt: v.optional(v.number()),
  cancelledAt: v.optional(v.number()),
  // Additional info
  notes: v.optional(v.string()),
  internalControl: internalControl,
});

export const logistics_orders = defineTable(validatorLogisticsOrder)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_payment_status", ["paymentStatus"])
  .index("by_company_and_payment_status", [
    "internalControl.companyId",
    "paymentStatus",
  ])
  .index("by_sender", ["senderId"])
  .index("by_company_and_sender", ["internalControl.companyId", "senderId"])
  .index("by_order_number", ["orderNumber"])
  .index("by_company_and_order_number", [
    "internalControl.companyId",
    "orderNumber",
  ])
  .index("by_shipment", ["shipmentId"])
  .index("by_company_and_shipment", ["internalControl.companyId", "shipmentId"])
  .index("by_qr_code", ["qrCode"])
  .index("by_company_and_order_code", [
    "internalControl.companyId",
    "orderCode",
  ])
  .searchIndex("search_logistics_orders", {
    searchField: "orderNumber",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "status",
      "paymentStatus",
      "senderId",
    ],
  });
